<template>
  <div class="wrapper" :class="contents.length <= 0 && 'no-content'">
    <template v-if="contents.length > 0">
      <div v-for="(content, i) in contents" :key="i">
        <gacha-list-cell :data="content" @try-gacha="tryGacha" />
      </div>
    </template>
    <template v-else>
      <div class="no-tickets">
        <img
          :src="noContentImage"
          alt=""
        />
        <p><span v-html="emptyContentMessage" /></p>
      </div>
    </template>
    <gacha-lottery-modal
      ref="lotteryModal"
      :needs-background-color="true"
      @finish-gacha="fetchContentsOnList(false)"
      @close-lottery-modal="closeLotteryModal"
    />
  </div>
</template>

<script>
import DateFormatter from '@/utils/DateFormatter'
import { mapActions, mapGetters } from 'vuex'
import GachaListCell from '@/views/Gacha/ListCell.vue'
import { GACHA_TAB_TYPE } from '@/store/gacha'
import GachaLotteryModal from '@/views/Gacha/LotteryModal.vue'
import NoTicketImage from '@/assets/img/gacha/no-tickets.svg'
import NoPrizeImage from '@/assets/img/gacha/no-prize.svg'

export default {
  name: 'GachaList',
  components: { GachaLotteryModal, GachaListCell },
  data() {
    return {
      apiType: '4',
      gachaTabTypeTicket: GACHA_TAB_TYPE.ticket
    }
  },
  created() {
  },
  computed: {
    ...mapGetters({
      selectedTab: 'Gacha/selectedTab',
      tickets: 'Gacha/tickets',
      prizes: 'Gacha/prizes'
    }),
    contents() {
      return this.selectedTab.key === GACHA_TAB_TYPE.ticket.key ?
        this.tickets :
        this.prizes
    },
    emptyContentMessage() {
      const suffix = '<br />はありません'
      return this.selectedTab.key === GACHA_TAB_TYPE.ticket.key ?
        `未使用のガチャ券${suffix}` :
        `これまでに獲得した特典${suffix}`
    },
    noContentImage() {
      return this.selectedTab.key === GACHA_TAB_TYPE.ticket.key ? NoTicketImage : NoPrizeImage
    }
  },
  watch: {
    selectedTab: {
      handler: function() {
        this.fetchContentsOnList()
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('Native', ['actionRequestToken']),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Gacha', ['fetchContents']
    ),
    async fetchContentsOnList(needsLoading = true) {
      const accTime = new DateFormatter().format(new Date())

      const fetch = async ({ token, accTime, userId }) => {
        this.actionToggleLoading(needsLoading)
        await this.fetchContents({ token, accTime, userId })
        this.actionToggleLoading(false)
      }

      window.receivedToken = async (payload) => {
        const json = JSON.parse(payload)
        await fetch({ token: json.app_token, accTime, userId: json.user_id })
      }
      this.actionRequestToken({ apiType: this.apiType, acc_time: accTime })
      // FIXME: for development
      // await fetch({ token: 'a', accTime, userId: '89a1636f6b85c0d7' })
    },
    tryGacha(historyId) {
      this.$refs.lotteryModal.tryGacha(historyId)
    },
    closeLotteryModal() {
      this.$refs.lotteryModal.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  flex: auto;
  padding-bottom: 75px;

  &.no-content {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 0;
  }

  .no-tickets {
    text-align: center;

    p {
      font-size: 16px;
      font-weight: bold;
      line-height: 1.38;
      text-align: center;
      color: #999999;
      margin-top: 2rem;
    }
  }
}

</style>
